export enum MapType {
    OSM,
    HIGHCHARTS
}
export enum MapType {
    OSM,
    HIGHCHARTS
}
